import React from "react";

const Check = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="100%"
      height="100%"
      viewBox="0 0 48 48"
      {...props}
    >
      <g data-name="Group 995" transform="translate(-770 -463)">
        <g fill="#63c132" data-name="Path 226">
          <path
            d="M23 46.5a23.42 23.42 0 01-16.617-6.883A23.42 23.42 0 01-.5 23 23.42 23.42 0 016.383 6.383 23.42 23.42 0 0123-.5a23.42 23.42 0 0116.617 6.883A23.42 23.42 0 0146.5 23c0 5.109-1.634 9.923-4.857 14.309-1.994 2.725-4.721 5.015-7.887 6.623A23.862 23.862 0 0123 46.5z"
            transform="translate(771 464)"
          ></path>
          <path
            fill="#283044"
            d="M23 0C10.297 0 0 10.297 0 23s10.297 23 23 23c7.622 0 14.377-3.707 18.24-8.987C44.352 32.777 46 28.08 46 23 46 10.297 35.703 0 23 0m0-1a23.919 23.919 0 0116.97 7.03A23.919 23.919 0 0147 23c0 5.218-1.667 10.131-4.954 14.605-2.04 2.787-4.828 5.13-8.064 6.773A24.365 24.365 0 0123 47a23.919 23.919 0 01-16.97-7.03A23.919 23.919 0 01-1 23 23.919 23.919 0 016.03 6.03 23.919 23.919 0 0123-1z"
            transform="translate(771 464)"
          ></path>
        </g>
        <path
          fill="#283044"
          d="M10.215 26.565L.44 16.79a1.5 1.5 0 010-2.127l2.127-2.127a1.5 1.5 0 012.127 0l6.585 6.585 14.1-14.1a1.5 1.5 0 012.127 0l2.127 2.127a1.5 1.5 0 010 2.127L12.342 26.566a1.5 1.5 0 01-2.127-.001z"
          data-name="Icon awesome-check"
          transform="translate(778.962 470.923)"
        ></path>
      </g>
    </svg>
  );
}

export default Check